const da = {
  sidebar: {
    merchant: {
      phone: 'Telefonnummer',
      vat: 'CVR',
      email: 'Email'
    },

    menu: {
      dashboard: 'Betjeningspanel',
      archive: 'Arkiv',
      payments: 'Betalinger',
      bookings: 'Booking',
      paymentinformation: 'Betalingsinformation',
      profile: 'Profil',
      paymentsettings: 'Betalingsindstillinger',
      wait_list: 'Venteliste',
      kamstrup: 'Vandforbrug',
      kamstrup_alarm_settings: 'Vandalarmer'
    },

    profile: {
      home: 'Hjem',
      profile: 'Profil',
      logout: 'Log ud'
    }
  },

  modals: {
    nets_notice: 'Du skal nu opsætte dit kort og forlader derfor Zietwing og fortsætter ind i Nets betalingsvindue.',
    mobile_pay_notice: 'Du vil nu blive omdirigeret til landingssiden og skal acceptere aftale i MobilePay-applikationen.',
    vipps_notice: 'Du vil nu blive omdirigeret til landingssiden og skal acceptere betaling i Vipps/MobilePay-applikationen.',
    vipps_notice_recurring: 'Du vil nu blive omdirigeret til landingssiden og skal acceptere aftalen i Vipps/MobilePay-applikationen.',
    vipps_notice_later: 'Du vil modtage en push-meddelelse i Vipps/MobilePay-applikationen på transaktionsdatoen ({transaction_date}) og skal acceptere betalingen.',
    overdue_payment_notice: 'Du er ved at betale {amount} DKK for forsinket transaktion.',

    overdue_fee: {
      unscheduled: 'Du er ved at betale {amount} DKK for forfaldent gebyr.'
    },

    booking: {
      mobile_pay_notice: 'Bemærk venligst, at med MobilePay-systemet betales reservationen under aktivering',
      vipps_notice: 'Bemærk venligst, at med Vipps/MobilePay reserveres beløbet ved aktivering og trækkes på betalingstidspunktet. Hvis betalingstidspunktet er mere end 4 dage frem, godkender du en aftale, og beløbet trækkes på betalingsdatoen.',
      booking_time_notice: 'Venligst vær opmærksom på at når bookingtid er udløbet er din reservation slut.'
    },

    logout: {
      areyousure: 'Er du sikker på du vil logge ud?'
    },

    changeemail: {
      header: 'Skift email',
      form: {
        new_email: 'Ny email',
        password: 'Kodeord'
      }
    },

    changepassword: {
      header: 'Skift kodeord',
      form: {
        old_password: 'Gammelt kodeord',
        new_password: 'Nyt kodeord',
        confirm_password: 'Gentag kodeord'
      }
    },

    newsubscriptionmodal: {
      product: {
        title: 'Produkt',
        description: 'Information om dit produkt',
        content: {
          description: 'Beskrivelse'
        }
      },

      accessories: {
        title: 'Tilbehør',
        description: 'Vælg tilbehør',
        content: {
          header: 'Vælg det ønskede tilbehør'
        }
      },

      details: {
        title: 'Detaljer',
        description: 'Produktdetaljer',
        content: {
          header: 'Detaljer',
          transaction_date: 'Overførselsdato',
          activation_later: 'Dit abonnement aktiveres senere',
        },

        agree_to: 'Jeg accepterer',
        terms: 'Vilkår og betingelser'
      },

      payment: {
        title: 'Betaling',
        description: 'Vælg betalingsinterval',
        content: {
          header: 'Vælg betalingsinterval',
          instant_payment: 'Det valgte beløb vil blive trukket med det samme når du aktiverer denne service'
        }
      },

      payment_method: {
        title: 'Betalingsmetode',
        description: 'Vælg Betalingsmetode',
        pay_by_card: 'Betal med kort',
        default_payment_method: 'Denne betalingsmetode er valgt på forhånd for produktet.'
      },

      validation: {
        nets: {
          success: {
            payment_created: 'Betaling oprettet med succes!',
            payment_completed: 'Betaling gennemført med succes! Aktiverer ...',
            subscription_added: 'Dit abonnement er tilføjet!',
            subscription_details_saved: 'Betalingsoplysningerne for abonnementet blev gemt! Aktiverer...',
            subscription_updated: 'Betalingsoplysninger er opdateret! Du omdirigeres om få sekunder.',
            subscription_added_with_failed_charge: 'Dit abonnement er tilføjet, men opladningen mislykkedes!'
          }
        },

        errors: {
          no_interval_selected: 'Vælg venligst et interval før du vælger betalingsmetode!',
          no_payment_method_selected: 'Vælg venligst en betalingsmetode, før du fortsætter!',
          not_accepting_terms: 'Accepter venligst vilkår og betingelser før du fortsætter.',
          not_accepting_warning_message: 'Accepter venligst advarselsmeddelelsen før du fortsætter!'
        }
      },

      intro: {
        readysubscribe: {
          title: 'Du er nu klar til at abonnere',
          content: 'Tryk på aktiver knappen for at færdiggøre din tilmelding.'
        },

        firstsubscription: {
          title: 'Tilmeldingsproces',
          content: 'Velkommen til tilmeldingsprocessen. Klik på næste for at fortsætte.'
        },

        productstab: {
          title: 'Produkter',
          content: 'Her finder du detaljer omkring dit produkt.'
        },

        accessoriestab: {
          title: 'Tilbehør',
          content: 'Her ser du det tilbehør som kan vælges for dit produkt. I nogle tilfælde kan tilbehør være obligatorisk. Vælg venligst det tilbehør du ønsker at tilføje.'
        },

        detailstab: {
          title: 'Detaljer',
          content: 'I nogle tilfælde vil du blive bedt om at udfylde mere information om dig selv eller det produkt du tilmelder dig. Du vil også blive bedt om at acceptere vilkår og betingelser. Gør venligst dette nu.'
        },

        forgotdetails: {
          title: 'Ups, du glemte vist noget..',
          content: 'Vær sikker på du har udfyldt felterne korrekt og har accepteret vilkår og betingelser.'
        },

        paymenttab: {
          title: 'Betalingsinterval',
          content: 'Du er næsten i mål! Nu er det tid til at vælge et interval. Når du har valgt et interval, vil du blive bedt om at tilføje et betalingskort. Vælg det ønskede interval her.'
        },

        payment_method: {
          title: 'Vælg den ønskede betalingsmetode',
          content: 'Hvis du foretrækker at bruge MobilePay, kan du vælge denne betalingsmetode for at aktivere abonnement.',
          content_vipps: 'Hvis du foretrækker at bruge Vipps, kan du vælge denne betalingsmetode for at aktivere abonnement.'
        }
      }
    },

    newwaitlistmodal: {
      validation: {
        success: {
          waitlist_added: 'Dit venteliste er tilføjet!',
          waitlist_added_with_failed_charge: 'Dit venteliste er tilføjet, men opladningen mislykkedes!',
          waitlist_details_saved: 'Betalingsoplysningerne for venteliste blev gemt! Aktiverer...',
        }
      }
    },

    newbookingmodal: {
      free: 'Gratis',
      guest: {
        title: 'Tager du en gæst med?',
        label: 'Jeg tager én gæst med',
        description: 'Reservér én ekstra saunaplads til din gæst. Saunaprisen og gæstegebyret lægges til totalprisen.',
        sauna_price: 'Saunapris',
        fee: 'Gæstegebyr',
        additional_cost: 'Ekstra pris',
        included: 'Denne booking inkluderer én gæst',
        price: 'Gæst (saunapris og gæstegebyr)',
        confirmation: 'Hvis du tilføjer en gæst, reserveres der én ekstra plads, og totalprisen stiger med {amount}. Vil du fortsætte?',
        capacity_unavailable: 'Du kan ikke tilføje en gæst, fordi der er færre end to ledige pladser på det valgte tidspunkt.',
        locked: 'Gæstevalget kan ikke ændres, efter betalingen er startet.'
      },
      select_active_subscription: 'Vælg et aktivt abonnement (felter markeret med en stjerne (*) er obligatoriske)',
      product: {
        title: 'Produkt',
        description: 'Information omkring din reservation',
        content: {
          description: 'Beskrivelse'
        }
      },

      time: {
        title: 'Tid',
        description: 'Book din tid',
        content: {
          no_time: 'Ingen tilgængelige tider'
        },
        no_available_slots: 'Desværre er der ingen ledige pladser tilbage i det valgte tidspunkt.',
        available_slots: 'Der er {amount} ledige pladser for det valgte tidspunkt.'
      },

      winter_place: {
        title: 'Vinterbådplads',
        description: 'Vælg vinterplads til din båd',
        title_not_chosen: 'Vælg vinterplads til din båd *',
        description_not_chosen: 'Klik på knappen nedenfor for at åbne billedet',
        title_chosen: 'Udvalgt vinterplads: {place}',
        description_chosen: 'Klik på knappen nedenfor for at åbne billedet og genvælge din vinterbådplads',
        open_image: 'Åbn kort',
        reset_view: 'Nulstil visning',
        close: 'Luk',
        confirm_message: 'Bekræft venligst, at du har valgt "{place}"',
        click_to_open: 'Klik på knappen nedenfor for at åbne kortet',
        existing_place: {
          title: 'Vigtigt',
          text1: 'Du har allerede valgt sektoren "{existingWinterPlace}".',
          text2: 'Vil du erstatte dit tidligere valg?',
          overwrite_checkbox: {
            label: 'Overskriv valgt sektor',
            modal_text: 'Hvis du fjerner markeringen i dette felt, vil den nuværende plads blive nulstillet til din tidligere valgte - {existingWinterPlace}. Er du sikker?'
          },
          bottom_text: 'Dit nuværende valg'
        }
      },

      details: {
        title: 'Detaljer',
        description: 'Booking detaljer',
        content: {
          header: 'Detaljer'
        }
      },

      warning_message: {
        title: 'Advarselsmeddelelse',
        description: 'Dobbelttjek dit valg',
        content: {
          header: 'Opmærksomhed',
          agree: 'Jeg er enig'
        }
      },

      confirm: {
        title: 'Bekræftelse',
        description: 'Bekræft din reservation',
        content: {
          header: 'Bekræft venligst detaljer om din reservation',

          time: 'Tid',

          pricing: 'Pris',

          validation: {
            no_date_picked: 'Ingen dato valgt',
            no_time_picked: 'Ingen tid valgt',
            no_year_picked: 'Intet år valgt',
            no_payment_method_picked: 'Ingen betalingsmetode valgt'
          }
        }
      },

      validation: {
        subscription_field: 'Sørg for, at du har valgt alle de nødvendige abonnementer (markeret med en stjerne (*))',
        not_all_subscriptions_chosen: "Ikke alle de nødvendige abonnementer er valgt. Kontakt venligst forhandleren ({merchant}) for at løse problemet.",

        nets: {
          success: {
            details_saved: 'Betalingsoplysninger er blevet gemt! Du bliver omdirigeret om få sekunder...'
          }
        },

        success: {
          booking_reserved: 'Din booking er blevet reserveret!',
          booking_reserved2: 'Du kan se dine bookede tider under "Booking" i sidepanelet til venstre'
        },

        errors: {
          something_is_missing: 'Der mangler noget!',
          fill_out_missing: 'Udfyld venligst de manglende data!',
          subscription_field_incorrect: 'Sørg for, at du har valgt alle de nødvendige abonnementer!',
          no_available_time: 'Desværre ingen ledige tidspunkter tilbage i den valgte periode!',
        }
      }
    },

    paymentterms: {
      header: 'Acceptér Forhandlerens betalingsbetingelser'
    },

    termsandconds: {
      accept_header: 'Acceptér vilkår og betingelser',
      normal_header: 'Vilkår og betingelser'
    },

    availableproducts: {
      header: 'Tilføj nyt produkt',

      card: {
        button: 'Tilføj produkt'
      },

      not_available: 'Ikke tilgængelig i øjeblikket',

      intro: {
        categories: {
          title: 'Kategorier',
          content: 'Her kan du se alle tilgængelige kategorier'
        },
        products: {
          title: 'Produkter',
          content: 'Her kan du vælge det ønskede produkt at abonnere på. Klik på "Tilføj produkt" for at fortsætte'
        }
      },

      validation: {
        success: {
          new_product: 'Nyt produkt tilføjet!',
          follow_process: 'Gennemgå venligst processen for at konfigurere din service.'
        }
      }
    },

    available_accessories: {
      not_available: 'Desværre er der ikke noget tilbehør tilbage på lageret. Kontakt venligst forhandler!'
    },

    missed_something: {
      title: 'Du mangler vist noget',
      header: 'Du har vist glemt at udfylde noget!',
      body: '<p><span class="ui label">{total}</span> produkt(er) er ikke blevet færdiggjort korrekt!</p><p>Tryk på "Næste" for at gøre det nu.</p>'
    },

    keep_going: {
      title: 'Bliv ved!',
      header: 'Du er ikke helt færdig endnu',
      body: '<p>Du har <span class="ui label">{total}</span> produkt(er) tilbage!</p> <p>Klik på  "Næste" for at fortsætte det gode arbejde!</p>'
    },

    social_number: {
      title: 'Socialnummer (CPR) mangler',
      header: 'Kære {username},',
      body: '<p>Indstil venligst dit sociale nummer i profilindstillinger. <br> Dette er nødvendigt for fakturering i <b>KMD Opus Debitor</b>. <br> Klik på "Næste" for at fortsætte.</p>'
    },

    overdue: {
      title: 'Du har forfaldne betalinger!',
      header: 'Klik venligst på "Betal" for at betale dit udestående',
      body: '<p>Dette kan skyldes, at dit betalingskort er udløbet eller har utilstrækkelige midler. Sørg venligst for, at dit betalingskort er gyldigt og opdateret.</p>',
      update_card: 'Opdater betalingskort'
    },

    expired_card: {
      title: 'Dit kreditkort er udløbet!',
      header: 'Kære {firstname} {surname},',
      body: '<p>Klik på "Næste" for at opdatere dine betalingsoplysninger for {container} <b>{product_name}</b>.</p>'
    },

    update_payment_card: {
      title: 'Forfaldne betaling ikke muligt!',
      header: 'Vi var ikke i stand til at opkræve forfaldne betaling. Tjek venligst dit betalingskort.',
      body: '<p>Klik på <b>"Næste"</b> for at opdatere betalingsoplysninger.</p><p>Du kan også opdatere dine betalingsoplysninger ved at klikke på knappen <b>"Skift kort"</b>.</p>'
    },

    payment_system_update: {
      title: 'Betalingsoplysninger mangler!',
      header: 'Kære {firstname} {surname},',
      body: '<p>Klik venligst på "Næste" for at tilføje dine betalingsoplysninger for {container} <b>"{product_name}"</b>.</p>'
    }
  },

  globals: {
    buttons: {
      yes: 'Ja',
      no: 'Nej',
      cancel: 'Afbryd',
      cancel_subscription: 'Afbryd abonnement',
      cancel_waitlist: 'Afbryd venteliste',
      cancel_booking: 'Afbryd booking',
      update: 'Opdater',
      edit: 'Rediger',
      save: 'Gem',
      save_and_complete: 'Gem & Gennemfør',
      save_changes: 'Gem ændringer',
      next: 'Næste',
      previous: 'Forrige',
      subscribe: 'Abonnér',
      activate: 'Aktiver',
      choose_paymentmethod: 'Vælg Betalingsmetode',
      accept: 'Accepter',
      change: 'Skift',
      select: 'Vælg',
      deselect: 'Fjern valg',
      delete: 'Slet',
      attach: 'Tilknyt',
      done: 'Afslut',
      close: 'Luk',
      skip: 'Skip',
      next_step: 'Næste',
      finalize: 'Afslut oprettelse',
      change_card: 'Skift kort',
      add_payment_method: 'Tilføj betalingsmetode',
      continue: 'Fortsæt',
      finish: 'Fuldfør',
      reserve: 'Reserver',
      open: 'Åben',
      pay: 'Betal',
      pay_overdue_fee: 'Betal forfaldent gebyr',
      overdue_fee_paid: 'Forfaldent gebyr betalt',
      pay_overdue_payment: 'Betal forfaldent betaling',
      pay_with_nets: 'Betal med Nets Easy',
      pay_with_mobilepay: 'Betal med MobilePay'
    },

    accessories: {
      no_accessory_left: 'Intet tilbehør tilbage på lager.',
      no_accessory_left_full: 'Intet tilbehør tilbage på lager. Kontakt venligst forhandler!'
    },

    container: {
      subscription: 'Abonnenter',
      waitlist: 'Venteliste',
      booked: 'Booking'
    },

    status: {
      'unset': 'Ufærdig',
      'deleted': 'Slettet',
      'active': 'Aktiv',
      'delayed': 'Kommende',
      'free': 'Gratis',
      'activating': 'I aktivering',
      'setup_processing': 'Opsætning af betalingsmetode'
    },

    months: [
      'Januar',
      'Februar',
      'Marts',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'December'
    ],

    monthsshort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Maj',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dec'
    ],

    loaders: {
      loading: 'Indlæser...'
    },

    validation: {
      success: {
        success: 'Succes!',
        payment_successful: 'Din tilknytning var succesfuld',
        overdue_fee_payment_successful: 'Det forfaldne gebyr er blevet betalt',
        overdue_payment_successful: 'Forsinket betaling succesfuld',
        startup_fee_payment_successful: 'Startgebyr betalt med succes'
      },

      warning: {
        warning: 'Advarsel!',
        not_all_steps_completed: 'Ups, der er noget galt. Din {0} er ufuldstændig. Kontakt venligst forhandler.'
      },

      errors: {
        error: 'Fejl..',
        payment_title: 'Betaling ikke gennemført',
        overdue_fee_payment_failed: 'Der opstod en fejl under opkrævning af forfaldent gebyr. Prøv venligst igen senere',
        overdue_payment_failed: 'Forsinket betaling mislykkedes',
        something_went_wrong: 'Noget gik galt...',
        payment_failed: 'Noget gik galt med din betaling...',
        nothing_found: 'Intet fundet...',
        oops_outdated_browser: 'Du benytter en gammel browser!',
        outdated_browser_message: 'Vi foreslår at downloade Google Chrome for en forbedret oplevelse. <a href="https://google.dk/chrome">Klik Her</a> for at downloade!',
        try_again_later: 'Prøv venligst igen senere..',
        charge_failed: 'Kort vedhæftet, men opladning mislykkedes.',
        contact_merchant: 'Prøv venligst igen senere, eller kontakt forhandleren..',
        missing_parameters: 'Du har ikke udfyldt alle felterne i din profil. Du omdirigeres på få sekunder!',
        startup_fee_payment_not_completed: 'Betaling af startgebyr ikke gennemført'
      },

      warnings: {
        are_you_sure: 'Er du sikker?'
      }
    },

    transactions: {
      no_card_attached: 'transaction declined (card missing)'
    },

    confirm: {
      confirm_leave: 'Vil du virkelig rejse? Du har ikke gemte ændringer!'
    },

    checkout: {
      title: 'Checkout',

      success: {
        title: 'Kassen gennemført!',
        payment_title: 'Betaling gennemført!',
        text: 'Oplysninger om dit {0} vil snart blive opdateret. Klik på knappen nedenfor for at fortsætte.',
        text_for_overdue: 'Betaling er blevet behandlet. Klik på knappen nedenfor for at fortsætte.',
        text_with_overdue_fee: 'Betalingsoplysninger er blevet tilføjet. Klik på knappen nedenfor for at fortsætte.',
        update_text: 'Oplysninger om dit {0} er blevet opdateret. Klik på knappen nedenfor for at fortsætte.',
        button_text: 'Blive ved'
      },

      failed: {
        title: 'Betaling ikke gennemført!',
        text: 'Desværre var vi ikke i stand til at gennemføre din betaling.',
        additional_text: 'Hvis dit {0} ikke er opdateret efter de næste 10 minutter, bedes du kontakte forhandleren!',
        click_to_continue_text: 'Klik på knappen nedenfor for at fortsætte.',
        button_text: 'Blive ved',

        vipps: {
          text: 'Din betaling er desværre stadig under behandling. Hvis du klikkede på knappen "Annuller betaling" på landingssiden, bedes du annullere betalingen i Vipps/MobilePay-applikationen. Ellers udløber din betaling om 10 minutter.'
        }
      }
    }
  },

  pages: {
    setup: {
      menu: {
        getstarted: {
          header: 'Velkommen til Zietwing',
          description: 'Hej {0} <br /> Gennemgå venligst oprettelsen for at komme i gang',

          button: 'Kom i gang!'
        },

        profilesetup: {
          header: 'Lad os få din profil oprettet',
          description: 'Vi har brug for nogle oplysninger om dig for at komme i gang. <br /> Udfyld venligst formularen til venstre.'
        },

        socialNumberSetup: {
          header: 'Angiv venligst dit personnummer (CPR)',
          description: 'Disse oplysninger vil kun blive vist i din profilsektion og vil blive brugt til at oprette <b>Fakturaer</b>. <br /> Please fill out the form on the left.'
        },

        companysetup: {
          header: 'Virksopmhedsinformation',
          description: 'Hvis du registrerer dig som virksomhed <br /> Udfyld venligst formularen til venstre'
        },

        paymentmethod: {
          header: 'Betalingsmetode',
          description: 'Registrér dit kort i Zietwing for at forbedre din brugeroplevelse'
        },

        firstservice: {
          header: 'Din første service',
          description: 'Klik nu på knappen til venstre for at starte oprettelsesprocessen'
        }
      },

      content: {
        profilesetup: {
          header: 'Profilopsætning',
          subtext: 'Lad os få oprettet din profil'
        },

        socialNumberSetup: {
          header: 'Opsætning af socialnummer',
          subtext: 'Angiv venligst dit personnummer (CPR)'
        },

        companysetup: {
          header: 'Virksomhedsinformation',
          subtext: 'Udfyld formularen nedenfor hvis du registrerer dig som virksomhed'
        },

        paymentmethod: {
          header: 'Betalingsmetode',
          subtext: 'Forbedre din brugeroplevelse ved at registrere dit kort i Zietwing',

          skiptext: 'Eller hvis du ønsker at springe over dette trin og udfylde det senere.',
          skip: 'Spring dette trin over'
        },

        firstservice: {
          header: 'Din første service',
          subtext: 'Lad os få dig oprettet så du kan benytte din første service',
          text: 'Du er næsten færdig! Den følgende guide vil hjælpe dig med at oprette din første service. Klik på knappen nedenfor for at starte',

          button: 'Okay, jeg er klar!'
        }
      },

      form: {
        firstname: 'Fornavn',
        lastname: 'Efternavn'
      },

      usersuccess: {
        header: 'Din konto er klar til brug!',
        message: 'Tak fordi du har sat din Zietwing konto op. <br /> På din profilside kan du altid ændre de oplysninger du har indtastet.',
        button: 'Ok, Super!'
      },

      validation: {
        success: {
          user_success: 'Dine bruger informationer er blevet gemt.',
          company_success: 'Dine firma informationer er blevet gemt.'
        }
      }
    },

    login: {
      header: 'Login',
      forgotpass: 'Glemt dit kodeord?',
      form: {
        email: 'Email',
        password: 'Adgangskode',
        remember: 'Husk mig',
        button: 'Login'
      },
      errors: {
        header: '<b>oops!</b> Noget gik galt!',
        missing_email_and_password: 'Indtast din email og adgangskode',
        missing_email: 'Indtast venligst din email',
        missing_password: 'Indtast venligst din adgangskode',
        invalid_credentials: 'ugyldige legitimationsoplysninger',
        something_went_wrong: 'Noget gik galt...'
      }
    },

    forgot: {
      header: 'Glemt adgangskode',
      form: {
        email: 'Email',
        button: 'Nulstil kodeord',
        success: 'Vi har sendt dig en email!'
      },

      goback: 'Gå tilbage til',
      loginlink: 'Login'
    },

    resetpassword: {
      header: 'Skift din adgangskode',
      form: {
        email: 'E-mail',
        password: 'Ny adgangskode',
        password_confirmation: 'Bekræft kodeord',

        button: 'Nulstil kodeord',

        success: 'Din adganskode er nu ændret.'
      },

      goback: 'Gå tilbage til',
      loginlink: 'Login',

      redirectlink: 'Klik her hvis du ikke automatisk bliver videresendt',

      validation: {
        success: {},

        errors: {
          link_invalid: 'Linket er ikke længere gyldigt,.',
          try_again: 'Prøv venligst igen senere, eller kontakt forhandleren.'
        }
      }
    },

    register: {
      header: 'Velkommen til Zietwing. Indtast venligst dit ønskede kodeord',

      form: {
        email: 'E-mail',
        password: 'Kodeord',
        password_confirmation: 'Bekræft kodeord',

        button: 'Opret',

        success: 'Oprettelse gennemført.',

        i_accept: 'Jeg accepterer',
        termsandconds: 'Vilkår og betingelser'
      },

      redirectlink: 'Klik her hvis du ikke automatisk bliver videresendt'
    },

    register_external: {
      form: {
        success: 'Tak for tilmeldingen! Du vil blive omdirigeret på få sekunder'
      },
      already_have_account: 'Har du allerede en bruger?',
      validation: {
        errors: {
          already_exist: 'Bruger med denne e-mailadresse findes allerede.',
          merchant_not_found: 'Desværre blev forhandleren ikke fundet. Prøv igen senere.'
        }
      }
    },

    dashboard: {
      title: 'Betjeningspanel',
      availproducts: 'Tilgængelige Produkter',

      details: {
        header: 'Abonnementsdetajler',
        subscriptions: 'Abonnement(er)',
        mobile_pay_instant_notice: 'Bemærk venligst, at du vil modtage en push-meddelelse i din MobilePay/Vipps-applikation på transaktionsdatoen og skal acceptere betalingen. Sørg for, at telefonnummeret i Profilindstillinger er korrekt og knyttet til din MobilePay/Vipps-applikation.',
        kamstrup: {
          headers: {
            meter_info: 'Information om vandmåler',
            meter_data: 'Måleraflæsningsdata'
          },
          meter_serial_number: 'Målerens serienummer',
          meter_type: 'Måler type',
          consumption_type: 'Forbrugstype',
          previous_period: 'Tidligere periode',
          current_period: 'Nuværende periode',
          from: 'Fra',
          to: 'Til',
          total: 'Total',
          payment: {
            upcoming: 'Betaling for nuværende periode vil snart blive udført!',
            overdue: 'Vi var ikke i stand til at udføre betaling for den nuværende periode!',
            no_updated_info: 'Så snart vandmålerdata dukker op i systemet, vil næste betaling blive opdateret!',
            no_data: 'Ingen målerdata endnu',
            paid: 'Betaling for indeværende periode er betalt!'
          }
        }
      },

      subscriptions: {
        header: 'Abonnementer',
        paymentinterval: 'Betalingsinterval',
        upcomingtrans: 'Kommende betaling(er)',
        processedpayment: 'Behandlede betalinger',
        paymethod: 'Betalingsmetode',
        accessories: 'Tilbehør',
        activation_on: 'Aktivering',
        period_price: 'Pris for perioden {start} – {end}',
        final_period_price: 'Betalt slutperiode {start} – {end}',
        final_period_paid: 'Slutperioden {start} – {end} er betalt. Der oprettes ikke flere automatiske betalinger for dette abonnement.',
        manually_adjusted: 'manuelt justeret',

        add_payment_method: {
          title: 'Tilføj betalingsmetode',
          description: 'Vælg en betalingsmetode til fremtidige automatiske betalinger. Du bliver ikke opkrævet under opsætningen.'
        },

        validation: {
          are_you_sure: 'Er du sikker på du vil afbryde dette abonnement?',
          are_you_sure_change_card: 'Er du sikker på, at du vil ændre kortet for produktet {product_name}?',
          are_you_sure_change_card_body_text_lead: 'Dit betalingskort opdateres kun for {product_name}.',
          are_you_sure_change_card_body_text_note: 'Hvis du har andre abonnementer, skal kortet opdateres separat for hvert produkt.'
        }
      }
    },

    archive: {
      title: 'Arkiverede abonnementer',
      meta: 'Arkiv',

      table: {
        'name': 'Navn',
        'interval': 'Interval',
        'price': 'Pris',
        'last_payment': 'Sidste betaling'
      }
    },

    payments: {
      header: 'Betaling',

      filter: {
        header: 'Transaktioner for {merchantname}',
        description: ''
      },

      payment: {
        processed: 'Behandlede betalinger',
        upcoming: 'Kommende betalinger',

        error: {
          noprocessedfound: 'Ingen behandlede betalinger fundet',
          noupcomingfound: 'Ingen kommende betalinger fundet'
        }
      }
    },

    bookings: {
      header: 'Booking',

      available_bookings: 'Tilgængelige produkter',

      reserved_bookings: {
        table: {
          product: 'Produkt',
          start_time: 'Start tid',
          end_time: 'Slut tid',
          status: 'Status',
          price: 'Pris',
          actions: 'Handlinger'
        },

        labels: {
          overview: 'Oversigt',
          calendar: 'Kalender',
          free: 'Gratis',
          pay: 'Betal',
          activate: 'Aktiver'
        }
      },

      validation: {
        delete_booking: {
          title: 'Er du sikker på du vil slette din booking?',
          header: 'Dette vil slette bookingen fra din profil',
          text: '<p>Den valgte dato og tid er måske ikke tilgængelig hvis du ønsker at booke den igen.<p/>'
        },

        error: {},

        success: {
          booking_deleted: 'Din booking er blevet slettet!',
          booking_added_free: 'Din reservation er blevet tilføjet!',
          booking_added_paid: 'Din reservation er blevet tilføjet! Betalingstid - {payment_time}',
          booking_paid: 'Din booking er betalt!',
          booking_agreement_confirmed: 'Din booking er bekræftet! Beløbet trækkes via Vipps/MobilePay på betalingsdatoen.',
          booking_edited: 'Din booking er opdateret!'
        }
      }
    },

    profile: {
      settings: {
        profile: {
          header: 'Profil',
          form: {
            email: 'Email',
            password: 'Adgangskode',
            change_password: 'Ændring af adgangskode kræver indtastning af den nuværende adgangskode',
            first_name: 'Fornavn',
            last_name: 'Efternavn',
            social_number: 'CPR nummer'
          }
        },

        privacy: {
          header: 'Privatlivsindstillinger',

          userdata: {
            header: 'Retten til indsigt',
            body: 'Du har ret til at se hvilke data Zietwing har gemt om dig og du kan anmode om at få dine brugerdata tilsendt.',
            button: 'Anmod brugerdata',

            modal: {
              title: 'Vil du anmode om dine brugerdata?',
              header: 'Anmod om at se hvilke data Zietwing har gemt om dig?',
              body: '<p>Du vil inden for 7-10 dage modtage en fil med de data Zietwing har gemt om dig, til fri disposition.</p>'
            }
          },

          forgotten: {
            header: 'Retten til at blive glemt',
            body: 'Som Zietwing bruger har du ret til at blive glemt. Zietwing sletter dine profildata.',
            button: 'Anmod at blive glemt',

            modal: {
              title: 'Sikker på du vil glemmes?',
              header: 'Zietwing vil glemme dine oplysninger.',
              body: '<p>Vi forventer at kunne behandle din anmodning inden for 7-10 dage. Denne handling er endegyldig og kan efterfølgende ikke fortrydes. Ønsker du at annullere din anmodning skal du kontakte Zietwing(<a href="mailto:support@zietwing.com">support@zietwing.com</a>) inden for 5 dage.</p><p>Zietwing informerer dine aktive forhandlere omkring din beslutning.</p>'
            },

            validation: {
              success: {
                request_received: 'Anmodning modtaget!',
                receive_message: 'Du vil modtage besked når du anmodning er behandlet.'
              }
            }
          }
        },

        documentation: {
          header: 'Dokumenter'
        },

        payment: {
          header: 'Betalingsindstillinger',
          button: 'Ny Betalingsmetode'
        }
      },

      validation: {
        success: {
          user: {
            saved: 'Profil Gemt',
            updated: 'Din profil er blevet opdateret!'
          },

          email: {
            saved: 'E-Mail',
            updated: 'Din e-mail er blevet opdateret!'
          },

          password: {
            saved: 'Kodeord Gemt',
            updated: 'Dit kodeord er blevet opdateret!'
          }
        }
      }
    },

    notfound: {
      not_found: 'Vi kunne ikke finde siden',
      go_back: 'Klik her for at gå tilbage'
    },

    wait_list: {
      header: 'Venteliste',
      available_products: 'Tilgængelige produkter',
      no_waitinglist: 'Ingen venteliste abonnementer fundet.'
    },

    checkout: {
      general: {
        title: 'Før du gennemfører din betaling:',
        hint_1: 'Kontroller dine kortoplysninger (kortnummer, udløbsdato og CVV)',
        hint_2: 'Sørg for, at dit kort er aktiveret til onlinebetalinger',
        hint_3: 'Hvis betalingen mislykkes, kan du prøve et andet kort eller kontakte din bank'
      },
      update: {
        title: 'Venligst tjek følgende informationer, før du fortsætter:',
        hint_1: 'Når du opdaterer betalingsoplysninger, vil Nets Easy reservere og annullere det angivne beløb.',
        hint_2: 'Opkrævningen vil ske på transaktionsdatoen.',
        hint_3: 'Glem venligst ikke at vende tilbage til browseren, efter du har bekræftet betalingen i mobilapplikationen (hvis nogen).'
      },
      kamstrup: {
        title: 'Venligst tjek følgende informationer, før du fortsætter:',
        hint_1: 'Ved den oprindelige opsætning er prisen 0.',
        hint_2: 'Dette beløb vil blive annulleret, så snart du har gennemført betalingen!',
        hint_3: 'Næste gebyrer afhænger af mængden af vand, der bruges.',
      }
    },

    water_usage: {
      title: 'Vandforbrug',
      meter_serial_number: 'Målerens serienummer',
      filter: {
        from: 'Fra',
        to: 'Til',
        house_meter: 'Adresse'
      },
      table: {
        date: 'Dato',
        start_meter: 'Start måler',
        end_meter: 'Slut måler',
        total: 'Forbrug (m³)',
        info_codes: 'Infokoder',
        pagination: {
          prev: 'Tidligere',
          next: 'Næste'
        }
      },
      hourly: {
        title: 'Vandforbrug pr. time',
        no_data: 'Der blev ikke fundet timeopdelt vandforbrug for den valgte dato.',
        total_per_day: 'Total for denne dag (m³)',
        table: {
          hour: 'Time'
        }
      }
    },

    kamstrup_alarm_settings: {
      title: 'Vandalarmer',
      description: 'Angiv egne alarmgrænser for vandforbrug på dine abonnementer.',
      default_settings: 'Standard fra udbyder: {threshold}% stigning og mindst {min} m3 forskel.',
      no_merchant_defaults: 'Udbyderen har ikke opsat standardindstillinger for alarmer. Du kan stadig oprette egne indstillinger for dine abonnementer.',
      no_subscriptions: 'Der er ingen aktive abonnementer til alarmindstillinger.',
      use_custom: 'Brug egne indstillinger',
      use_default: 'Brug standard',
      threshold_percentage: 'Stigning i procent',
      min_absolute_volume: 'Minimum forskel (m3)',
      max_daily_volume: 'Maksimalt dagligt forbrug (m3)',
      max_daily_volume_help: 'Valgfrit. Brug dette til at få alarm, når en enkelt dag bruger for meget vand, også selvom forbruget ikke stiger i forhold til dagen før.',
      optional: 'Valgfrit',
      required_fields: 'Stigning i procent og minimum forskel skal udfyldes.',
      saved: 'Alarmindstillinger gemt.',
      threshold_percentage_help: 'Hvor meget højere gårsdagens forbrug skal være i forhold til dagen før.',
      min_absolute_volume_help: 'Forhindrer alarmer ved meget små ændringer. 0,20 m3 svarer til ca. 200 liter.',
      how_it_works: {
        title: 'Sådan sendes alarmer',
        intro: 'Hver dag sammenligner systemet gårsdagens vandforbrug med dagen før.',
        percentage_title: 'Stigning i procent',
        percentage_text: 'Der kan sendes alarm, når gårsdagens forbrug er så mange procent højere end dagen før. Eksempel: Hvis dette er 50%, er forbrug fra 0,40 til 0,70 m3 højt nok målt i procent.',
        minimum_title: 'Minimum forskel',
        minimum_text: 'Stigningen skal også være mindst så mange m3. Eksempel: Hvis dette er 0,20 m3, sendes der ikke alarm ved forbrug fra 0,40 til 0,50 m3, fordi forskellen kun er 0,10 m3.',
        maximum_title: 'Maksimalt dagligt forbrug',
        maximum_text: 'Valgfrit. Dette er en fast grænse pr. dag. Eksempel: Hvis dette er 1,00 m3, sendes der alarm for alle dage hvor det samlede forbrug er 1,00 m3 eller mere, også hvis gårsdagen og dagen før brugte samme mængde.'
      }
    }
  },

  components: {
    languageselector: {
      header: 'Sprog',

      languages: {
        danish: 'Dansk',
        english: 'Engelsk'
      }
    },

    notificationbell: {
      header: 'Notifikationer',
      new: 'nye',
      messages: {
        service_unset: 'Denne service er ikke korrekt udfyld, klik her for at færdiggøre.',
        no_new: 'Ingen nye notifikationer fundet'
      }
    },

    transaction: {
      paymentstatus: {
        approved: 'Betaling godkendt',
        approved_manually: 'Manuel betaling godkendt',
        denied: 'Betaling afvist',
        upcoming: 'Kommende betaling',
        overdue: 'Betalingsdatoen er overskredet'
      },

      info: {
        paymentinfo: 'Dine betalingsoplysninger',
        overdue_fee: 'Forfaldent gebyr',
        endingin: 'Slutter i',
        paid: 'Betalt d. {date} kl. {time}',
        to_be_paid: 'Bliver betalt d. {date}',
        tried: 'Betaling prøvet d. {date} kl. {time}',
        fail_reason: 'Beskrivelse: {reason}',
        refunding: 'Transaktionen refunderes i øjeblikket',
        refunded: 'Betalingen blev refunderet d. {date} kl. {time}',
        accessories: 'Tilbehør',
        merchantinfo: 'Information om forhandler',
        expire_date: 'Udløbsdato',
        purchase: 'Dit køb',
        total: 'Total',
        water_rate: 'Vandtakst (pr. m³)',
        pending_meter_notice: 'Dette er taksten pr. kubikmeter. Endelig opladning baseres på vandforbrug.',
        accessories_included: 'Tilbehør inkluderet i ovenstående takst'
      }
    },

    accessory: {
      added: 'Tilføjet',
      select: 'Vælg',
      mandatory: 'Obligatorisk'
    },

    paymentplan: {
      chosen_accessory: 'Valgt Tilbehør',
      chosen_product: 'Valgt Produkt',
      starting_fee: 'Oprettelsesgebyr',

      intervals: {
        instant: 'Straks',
        monthly: 'Månedlig',
        quarterly: 'Kvartalsvis',
        biannually: 'Halvårlig',
        annually: 'Årlig'
      }
    },

    card: {
      card_holder: 'Kortholder',
      expires: 'Udløber',
      no_card: 'Intet betalingskort'
    },

    service: {
      payment_date: 'Betalings dato:',
      payment_type: 'Betalingstype',
      payment_method: 'Betalingsmetode',
      price: 'Pris',
      unset: 'Ikke valgt',
      no_price: 'Ingen pris',
      select_status: 'Vælg status',

      status: {
        inactive: 'Inaktiv',
        active: 'Aktiv',
        unset: 'Ikke færdiggjort',
        overdue: 'Forfalden'
      },

      details: {
        header: 'Detaljer'
      },

      transactions: {
        header: 'Seneste transaktioner'
      },

      validation: {
        cancel_service: 'Er du sikker på du vil annullere dit venteliste?',
        update_payment_information: 'Er du sikker på, at du vil opdatere dine betalingsoplysninger?',

        success: {
          service_cancelled: 'Abonnementet er blevet annulleret.',
          details_updated: 'Dine detaljer er blevet gemt.'
        }
      }
    }
  }
}

export default da



// WEBPACK FOOTER //
// ./src/assets/lang/da.js